<template>
    <v-container fluid>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap justify-center>
            <v-flex xs12 sm6>
                <!--TVA Sports-->
                    <v-card>
                        <a href="https://youtu.be/bzIcO4pLXn8?t=413" target="_blank">
                        <v-img
                                :src="require('../assets/reportageTVASports.png')"
                                height="100%"
                                width="100%">
                        </v-img>
                        </a>

                        <v-card-title primary-title>
                            <div>
                                <div class="headline">
                                    <a href="https://youtu.be/bzIcO4pLXn8?t=413" target="_blank" style="text-decoration: none">
                                        Reportage de Jonathan Fournier à TVA Sports, le jeudi 3 mai 2018
                                    </a>
                                </div>
                            </div>
                        </v-card-title>

                        <v-card-actions>

                        </v-card-actions>
                    </v-card>
            </v-flex>

                <!-- Brouillard communication-->
            <v-flex xs12 sm6>
                <v-card>
                    <a href="http://brouillardcommunication.com/a-temps-beau-temps-lancement-camion-veloshop-ca-a-quebec/" target="_blank">
                        <v-img
                                :src="require('../assets/brouillardCommunication.png')"
                                height="100%"
                                width="100%">
                        </v-img>
                    </a>

                    <v-card-title primary-title>
                        <div>
                            <div class="headline">
                                <a href="http://brouillardcommunication.com/a-temps-beau-temps-lancement-camion-veloshop-ca-a-quebec/" style="text-decoration: none">
                                    Communiqué Brouillard Communication
                                </a>
                            </div>
                        </div>
                    </v-card-title>

                    <v-card-actions>

                    </v-card-actions>
                </v-card>
            </v-flex>

                <!-- Magazine Circulation Québec-->
            <v-flex xs12 sm6>
                <v-card>
                    <a href="http://circulationquebec.net/artman2/publish/sports/VELOSHOP_ca_nouvel_alli_pour_les_cyclistes.shtml" target="_blank">
                        <v-img
                                :src="require('../assets/vanMedia.png')"
                                height="100%"
                                width="100%">
                        </v-img>
                    </a>

                    <v-card-title primary-title>
                        <div>
                            <div class="headline">
                                <a href="http://circulationquebec.net/artman2/publish/sports/VELOSHOP_ca_nouvel_alli_pour_les_cyclistes.shtml" style="text-decoration: none">
                                    Site du Magazine Internet de Circulation Québec, le 2 mai 2018
                                </a>
                            </div>
                        </div>
                    </v-card-title>

                    <v-card-actions>

                    </v-card-actions>

                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

        <!-- footer-->
        <v-layout justify-center>
            <v-flex xs12>
                <v-footer
                        dark
                        height="auto">
                    <v-card
                            class="flex"
                            flat
                            tile>
                        <v-card-title class="teal">
                            <h2>SUIVEZ-NOUS!</h2>
                            <v-divider light></v-divider>
                            <v-btn fab light href="https://www.facebook.com/veloshop.ca/" target="_blank">
                                <v-icon size="24px">fab fa-facebook</v-icon>
                            </v-btn>
                            <v-btn fab light href="https://www.instagram.com/veloshop.ca/?hl=en" target="_blank">
                                <v-icon size="24px">fab fa-instagram</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-actions class="grey darken-3 justify-center">
                            &copy;2019 — <strong>Véloshop.ca</strong>
                        </v-card-actions>

                    </v-card>
                </v-footer>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    export default {
        name: "Medias",
        data: () => ({

        })
    }
</script>

<style scoped>

</style>
